import { Link } from "react-router-dom";

const Breadcrumb = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <nav className="flex flex-col sm:flex-row sm:items-center gap-1 text-sm font-bold text-gray-600 max-w-full">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1">
            {isLast ? (
              <span className="font-semibold text-rs-azul">{item.label}</span>
            ) : (
              <Link to={item.to} className="hover:underline break-words">
                {item.label}
              </Link>
            )}
            {!isLast && <span className="hidden sm:inline">/</span>}
          </span>
        );
      })}
    </nav>
  );
};
export default Breadcrumb;